module.exports = __webpack_public_path__ + "static/img/son8_active.69d4688e.jpg";